import React from 'react';

const ServiceCategory = ({ title, services }) => (
  <div className="service-card" style={{
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    flex: '1 1 300px',
    minWidth: '280px'
  }}>
    <h3 style={{
      fontSize: '1.5rem',
      color: '#1a73e8',
      marginBottom: '15px'
    }}>{title}</h3>
    <ul style={{
      paddingLeft: '20px',
      color: '#555',
      fontSize: '1rem',
      lineHeight: 1.6
    }}>
      {services.map((s, i) => <li key={i}>{s}</li>)}
    </ul>
  </div>
);

const Services = () => {
  return (
    <section id="services" style={{
      padding: '80px 5%',
      backgroundColor: '#f9f9f9'
    }}>
      <h2 style={{
        fontSize: '2.5rem',
        textAlign: 'center',
        marginBottom: '50px',
        color: '#1a73e8'
      }}>Our Services</h2>

      <div className="services-grid" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '30px'
      }}>
        <ServiceCategory 
          title="Market & Commercial Strategies"
          services={[
            'Commercial Feasibility studies',
            'Commercial model design',
            'Market entry strategies',
            'Market access & electricity/gas market design',
            'Retail competition and tariff analysis',
          ]}
        />

        <ServiceCategory 
          title="Bilateral Contract Advisory & Brokering"
          services={[
            'Power Purchasing Agreement (PPA) Structuring',
            'PPA Negotiating',
            'PPA Brokering',
            'Power/Gas Contract Hedging ',
            'Support on other agreements for Natural Gas/LNG'
          ]}
        />

        <ServiceCategory 
          title="Market Modelling & Analytics"
          services={[
            'Modeling power, gas & hydrogen Systems',
            'Long-term capacity planning',
            'Market Price Projections',
            'BESS/storage optimization',
            'Energy consumption and demand analysis',
            'Energy data toolchain optimization',
            'Machine & deep learning forecasting models',
            'Revenue stacking & market trend analytics'
          ]}
        />

        <ServiceCategory 
          title="Management Consulting"
          services={[
            'Funding Application Support',
            'Expert witness/Litigation Support',
            'Permitting/Licensing',
            'Financial Modeling',
            'Financing Support'
          ]}
        />
      </div>

      {/* Hover interaction styling */}
      <style>{`
        .services-grid:hover .service-card {
          opacity: 0.5;
        }

        .service-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
          opacity: 1 !important;
        }
      `}</style>
    </section>
  );
};

export default Services;
